import { actions } from "./state";

export const changeKunjungan = (props) => {
	return {
		type: actions.CHANGE_KUNJUNGAN,
		payload: props,
	};
};

export const changeLoading = (props) => {
	return {
		type: actions.CHANGE_LOADING,
		payload: props,
	};
};
